// PWA-related utilities for Vue components

export const useAuthUser = () => {
  // In a real app, this would get the authenticated user from Pinia store or useCookie
  return useState('auth-user', () => null)
}

export const getServiceWorkerUrl = (baseURL) => {
  const base = (baseURL || '/').replace(/\/+$/, '')
  const prefix = base && base !== '/' ? `${base}/` : '/'
  return `${prefix}sw.js`
}

export const registerPwaServiceWorker = async () => {
  if (typeof window === 'undefined' || !('serviceWorker' in navigator)) return null

  try {
    const swUrl = getServiceWorkerUrl(useRuntimeConfig().app.baseURL)

    // Avoid double registration of the same worker
    const existing = await navigator.serviceWorker.getRegistration().catch(() => null)
    if (existing) return existing

    return await navigator.serviceWorker.register(swUrl)
  } catch (err) {
    console.warn('PWA Service Worker registration failed:', err)
    return null
  }
}

export const useConnectionStatus = () => {
  const isOnline = ref(true)
  
  if (process.client) {
    isOnline.value = navigator.onLine
    
    const updateStatus = () => {
      isOnline.value = navigator.onLine
    }
    
    window.addEventListener('online', updateStatus)
    window.addEventListener('offline', updateStatus)
    
    // Clean up on unmount
    onUnmounted(() => {
      window.removeEventListener('online', updateStatus)
      window.removeEventListener('offline', updateStatus)
    })
  }
  
  return { isOnline }
}

export const useShareProduct = (product) => {
  const shareUrl = computed(() => {
    if (process.client) {
      return `${window.location.origin}/market/details/${product.value.invoiceNum}`
    }
    return 'https://sarvban.com/market/details/' + product.value.invoiceNum
  })
  
  const shareText = computed(() => {
    return product.value.title
  })
  
  const shareOnWhatsApp = () => {
    if (process.client) {
      window.open(`https://api.whatsapp.com/send?text=${encodeURIComponent(shareUrl.value)}`, '_blank')
    }
  }
  
  const shareOnTelegram = () => {
    if (process.client) {
      window.open(
        `https://t.me/share/url?url=${encodeURIComponent(shareUrl.value)}&text=${encodeURIComponent(shareText.value)}`, 
        '_blank'
      )
    }
  }
  
  return {
    shareUrl,
    shareText,
    shareOnWhatsApp,
    shareOnTelegram
  }
}

export const usePersianNumberFormat = () => {
  const formatNumber = (number) => {
    if (!number) return ''
    return new Intl.NumberFormat('en-US').format(number)
  }
  
  const formatPrice = (number) => {
    return formatNumber(number) + ' تومان'
  }
  
  return {
    formatNumber,
    formatPrice
  }
}